<template>
  <div class="main-footer">
    <div
      v-if="position === 'teacher' || position === 'prof-teacher'"
      class="teacher prof"
      style="margin-top: 136px;"
    >
     
      <TeacherProfileButton
        :route="isProfteacher ? 'teacher-educational-games' : 'teacher-profile'"
      >
        <span class="icon">
          <svg
            width="35"
            height="33"
            viewBox="0 0 35 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.56239 0C3.35237 0 2.19191 0.474106 1.33629 1.31802C0.480679 2.16193 0 3.30653 0 4.5C0 5.69347 0.480679 6.83807 1.33629 7.68198C2.19191 8.5259 3.35237 9 4.56239 9C5.77241 9 6.93288 8.5259 7.78849 7.68198C8.64411 6.83807 9.12478 5.69347 9.12478 4.5C9.12478 3.30653 8.64411 2.16193 7.78849 1.31802C6.93288 0.474106 5.77241 0 4.56239 0ZM12.1664 1.5V4.5H30.4159V21H12.1664V22.248C12.1392 22.41 12.1392 22.5753 12.1664 22.7373V24H31.9367H33.4575C33.6591 24.0028 33.8591 23.9661 34.0462 23.892C34.2332 23.8178 34.4034 23.7078 34.5469 23.5682C34.6904 23.4287 34.8044 23.2624 34.8822 23.079C34.9599 22.8956 35 22.6988 35 22.5C35 22.3012 34.9599 22.1044 34.8822 21.921C34.8044 21.7376 34.6904 21.5713 34.5469 21.4318C34.4034 21.2922 34.2332 21.1822 34.0462 21.108C33.8591 21.0339 33.6591 20.9972 33.4575 21V3C33.4575 2.60219 33.2973 2.22068 33.0121 1.93938C32.7269 1.65809 32.3401 1.50004 31.9367 1.5H12.1664ZM3.04159 12C1.36111 12 0 13.3425 0 15V24H9.12478V16.5C9.12478 15.672 9.8061 15 10.6456 15H12.1664H18.2496C18.4511 15.0028 18.6512 14.9661 18.8382 14.892C19.0252 14.8178 19.1954 14.7078 19.3389 14.5682C19.4824 14.4287 19.5964 14.2624 19.6742 14.079C19.752 13.8956 19.792 13.6988 19.792 13.5C19.792 13.3012 19.752 13.1044 19.6742 12.921C19.5964 12.7376 19.4824 12.5713 19.3389 12.4318C19.1954 12.2922 19.0252 12.1822 18.8382 12.108C18.6512 12.0339 18.4511 11.9972 18.2496 12H12.1664H7.60399H3.04159ZM3.04159 27C2.23491 27 1.46127 27.3161 0.890862 27.8787C0.320453 28.4413 0 29.2044 0 30C0 30.7956 0.320453 31.5587 0.890862 32.1213C1.46127 32.6839 2.23491 33 3.04159 33C3.84828 33 4.62192 32.6839 5.19233 32.1213C5.76274 31.5587 6.08319 30.7956 6.08319 30C6.08319 29.2044 5.76274 28.4413 5.19233 27.8787C4.62192 27.3161 3.84828 27 3.04159 27ZM12.1664 27C11.3597 27 10.5861 27.3161 10.0156 27.8787C9.44524 28.4413 9.12478 29.2044 9.12478 30C9.12478 30.7956 9.44524 31.5587 10.0156 32.1213C10.5861 32.6839 11.3597 33 12.1664 33C12.9731 33 13.7467 32.6839 14.3171 32.1213C14.8875 31.5587 15.208 30.7956 15.208 30C15.208 29.2044 14.8875 28.4413 14.3171 27.8787C13.7467 27.3161 12.9731 27 12.1664 27ZM21.2912 27C20.4845 27 19.7108 27.3161 19.1404 27.8787C18.57 28.4413 18.2496 29.2044 18.2496 30C18.2496 30.7956 18.57 31.5587 19.1404 32.1213C19.7108 32.6839 20.4845 33 21.2912 33C22.0978 33 22.8715 32.6839 23.4419 32.1213C24.0123 31.5587 24.3328 30.7956 24.3328 30C24.3328 29.2044 24.0123 28.4413 23.4419 27.8787C22.8715 27.3161 22.0978 27 21.2912 27ZM30.4159 27C29.6093 27 28.8356 27.3161 28.2652 27.8787C27.6948 28.4413 27.3744 29.2044 27.3744 30C27.3744 30.7956 27.6948 31.5587 28.2652 32.1213C28.8356 32.6839 29.6093 33 30.4159 33C31.2226 33 31.9963 32.6839 32.5667 32.1213C33.1371 31.5587 33.4575 30.7956 33.4575 30C33.4575 29.2044 33.1371 28.4413 32.5667 27.8787C31.9963 27.3161 31.2226 27 30.4159 27Z"
              fill="white"
            />
          </svg>
        </span>

        <span style="margin-right: 20px" class="title">
          {{ $ml.get("כיתה משחקת") }}
        </span>
      </TeacherProfileButton>
    </div>
    <div v-else-if="position === 'director'" class="director" style="margin-top: 136px;">
      <TeacherProfileButton
        bgColor="#06364B"
        textColor="#FFFFFF"
        route="director-profile"
      >
        <span class="icon">
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 0C8.07496 0 0 8.07496 0 18C0 27.925 8.07496 36 18 36C27.925 36 36 27.925 36 18C36 14.4023 34.9354 11.05 33.1095 8.23421L32.411 8.93274L31.9647 9.37908C33.5205 11.8889 34.4348 14.8359 34.4348 18C34.4348 27.0626 27.0626 34.4348 18 34.4348C8.93739 34.4348 1.56522 27.0626 1.56522 18C1.56522 8.93739 8.93739 1.56522 18 1.56522C21.8452 1.56522 25.3724 2.9093 28.1739 5.13128V6.71943L26.2678 8.62551C24.0606 6.67361 21.171 5.47826 18 5.47826C11.0958 5.47826 5.47826 11.0958 5.47826 18C5.47826 24.9042 11.0958 30.5217 18 30.5217C24.9042 30.5217 30.5217 24.9042 30.5217 18C30.5217 15.3947 29.72 12.973 28.3528 10.9672L27.2186 12.1014C28.3127 13.8067 28.9565 15.8275 28.9565 18C28.9565 24.0417 24.0417 28.9565 18 28.9565C11.9583 28.9565 7.04348 24.0417 7.04348 18C7.04348 11.9583 11.9583 7.04348 18 7.04348C20.7401 7.04348 23.2396 8.06223 25.1612 9.73217L22.3854 12.508C21.1812 11.5421 19.6603 10.9565 18 10.9565C14.1167 10.9565 10.9565 14.1167 10.9565 18C10.9565 21.8833 14.1167 25.0435 18 25.0435C21.8833 25.0435 25.0435 21.8833 25.0435 18C25.0435 16.9145 24.7893 15.8908 24.3495 14.972L23.1557 16.1642C23.3608 16.7387 23.4783 17.3559 23.4783 18C23.4783 21.0209 21.0209 23.4783 18 23.4783C14.9791 23.4783 12.5217 21.0209 12.5217 18C12.5217 14.9791 14.9791 12.5217 18 12.5217C19.2287 12.5217 20.3597 12.9334 21.2741 13.6192L18.4035 16.4898C18.272 16.454 18.1363 16.4355 18 16.4348C17.5849 16.4348 17.1868 16.5997 16.8932 16.8932C16.5997 17.1868 16.4348 17.5849 16.4348 18C16.4348 18.4151 16.5997 18.8132 16.8932 19.1068C17.1868 19.4003 17.5849 19.5652 18 19.5652C18.4151 19.5652 18.8132 19.4003 19.1068 19.1068C19.4003 18.8132 19.5652 18.4151 19.5652 18C19.5652 17.8632 19.5472 17.727 19.5117 17.5949L29.2806 7.82609H31.3043L35.2174 3.91304H32.087V0.782609L29.0559 3.81369C26.0021 1.42775 22.1669 0 18 0Z"
              fill="white"
            />
          </svg>
        </span>

        <span style="margin-right: 20px" class="title">
          {{ $ml.get("קביעת יעדים") }}
        </span>
      </TeacherProfileButton>
    </div>
    <div v-else class="relative-div" style="margin-bottom: 20px;margin-top: 5px;">
      <div class="absolute-div">
        <div class="inside-div">
          <div class="line" style="padding: 0px 25px 2px 0px;">
              <hr  >
            </div>
        </div>
        <div class="inside-div">
          <span v-if="index==1" class="title-inside">{{ $ml.get("אזור הורים") }}</span>
          <span v-else-if="index==0" class="title-inside">{{ $ml.get("אזור מבוגרים") }}</span>
        </div>
         <div class="inside-div">
          <div class="line" style="padding: 0px 0px 2px 25px;">
              <hr  >
            </div>
         </div>
      </div>
      <div style="position: relative; width: 85%;
    margin: auto;">
        <VueSlickCarousel @afterChange="afterChange" ref="carousel" class="test"  :initalSlide="1" :infinite="false" :slidesToShow="1" :slidesToScroll="1" :arrows="false" :dots="false" :rtl="true">
          <div>
            <div class="links-element student" style="margin: auto;width: 90% !important;">
              <router-link
                :to="{
                  name: 'seven-page',
                  params: { id: $store.getters['user/data'].id_user,student: true },
                }"
              >
              <svg width="40" height="40" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.58065 0C8.22034 0 7.08298 0.922762 6.76243 2.16211C6.28307 2.34208 5.8191 2.55134 5.39074 2.8141C3.15444 4.18744 1.6662 6.63365 1.6662 9.40909C1.6662 9.81205 1.70298 10.207 1.76383 10.5948C1.19411 11.1178 0.8331 11.8573 0.8331 12.6818C0.8331 13.6733 1.34973 14.5487 2.13156 15.0629C0.897119 15.5818 0 16.666 0 18H1.6662C1.6662 17.1601 2.52444 16.3636 3.74895 16.3636C4.97345 16.3636 5.8317 17.1601 5.8317 18H7.4979C7.4979 16.666 6.60078 15.5818 5.36633 15.0629C5.80043 14.7774 6.14462 14.3753 6.37191 13.9091H12.7894C13.0167 14.3753 13.3609 14.7774 13.795 15.0629C12.5605 15.5818 11.6634 16.666 11.6634 18H13.3296C13.3296 17.1601 14.1878 16.3636 15.4123 16.3636C16.6368 16.3636 17.4951 17.1601 17.4951 18H19.1613C19.1613 16.666 18.2642 15.5818 17.0297 15.0629C17.8116 14.5487 18.3282 13.6733 18.3282 12.6818C18.3282 11.8573 17.9672 11.1178 17.3975 10.5948C17.4583 10.207 17.4951 9.81205 17.4951 9.40909C17.4951 6.63437 16.007 4.18753 13.7706 2.8141C13.3422 2.55134 12.8782 2.34208 12.3989 2.16211C12.0783 0.922762 10.9409 0 9.58065 0ZM9.58065 1.63636C10.2696 1.63636 10.8303 2.187 10.8303 2.86364C10.8303 3.54027 10.2696 4.09091 9.58065 4.09091C8.89167 4.09091 8.331 3.54027 8.331 2.86364C8.331 2.187 8.89167 1.63636 9.58065 1.63636ZM6.86656 3.88796C7.08451 4.44296 7.46684 4.9182 7.96326 5.24467C6.72882 5.76364 5.8317 6.8478 5.8317 8.18182H7.4979C7.4979 7.34192 8.35614 6.54545 9.58065 6.54545C10.8051 6.54545 11.6634 7.34192 11.6634 8.18182H13.3296C13.3296 6.8478 12.4325 5.76364 11.198 5.24467C11.6945 4.9182 12.0768 4.44296 12.2947 3.88796C12.4979 3.98461 12.6981 4.0859 12.8886 4.20277C14.6544 5.28716 15.8289 7.20763 15.8289 9.40909C15.8289 9.56006 15.8203 9.70876 15.8094 9.85653C15.6784 9.8388 15.5482 9.81818 15.4123 9.81818C13.947 9.81818 12.7429 10.8883 12.5388 12.2727H6.62249C6.41835 10.8883 5.21428 9.81818 3.74895 9.81818C3.61312 9.81818 3.48286 9.8388 3.35192 9.85653C3.34098 9.70876 3.3324 9.56006 3.3324 9.40909C3.3324 7.20672 4.50674 5.28724 6.27265 4.20277C6.46318 4.0859 6.66342 3.98461 6.86656 3.88796ZM3.74895 11.4545C4.43792 11.4545 4.9986 12.0052 4.9986 12.6818C4.9986 13.3585 4.43792 13.9091 3.74895 13.9091C3.05997 13.9091 2.4993 13.3585 2.4993 12.6818C2.4993 12.0052 3.05997 11.4545 3.74895 11.4545ZM15.4123 11.4545C16.1013 11.4545 16.662 12.0052 16.662 12.6818C16.662 13.3585 16.1013 13.9091 15.4123 13.9091C14.7234 13.9091 14.1627 13.3585 14.1627 12.6818C14.1627 12.0052 14.7234 11.4545 15.4123 11.4545Z" fill="white"/>
              </svg>
                

                <span> {{$ml.get($store.getters['pagestitle/data'].find(x=>x.name=='Seven_page').data[0])}} </span>
              </router-link>
              <div class="lined"></div>
              <router-link :to="{ name: 'eight-page', params: { student: true }, }">
            
                
                    <svg  width="40" height="40" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 0C7.58622 0 6.42857 1.14595 6.42857 2.54545C6.42857 3.20419 6.69224 3.80078 7.11161 4.25568C6.85045 4.38246 6.61942 4.53906 6.38839 4.71307C6.20257 3.49006 5.14035 2.54545 3.85714 2.54545C2.44336 2.54545 1.28571 3.69141 1.28571 5.09091C1.28571 5.76953 1.56445 6.38352 2.00893 6.84091C1.84319 6.9304 1.67746 7.02734 1.52679 7.1392C0.600168 7.83523 0 8.94389 0 10.1818H1.28571C1.28571 9.34908 1.69001 8.61825 2.31027 8.15341C2.74219 7.83026 3.27204 7.63636 3.85714 7.63636C4.25642 7.63636 4.63058 7.74325 4.98214 7.91477L5.68527 8.25284L5.88616 7.49716C6.23772 6.12003 7.49079 5.09091 9 5.09091C10.5067 5.09091 11.7598 6.10263 12.1138 7.47727L12.3147 8.25284L13.0179 7.89489C13.3644 7.72585 13.7411 7.63636 14.1429 7.63636C15.5692 7.63636 16.7143 8.76989 16.7143 10.1818H18C18 8.74751 17.1814 7.49219 15.9911 6.84091C16.4355 6.38352 16.7143 5.76953 16.7143 5.09091C16.7143 3.69141 15.5566 2.54545 14.1429 2.54545C12.8597 2.54545 11.7974 3.49006 11.6116 4.71307C11.3806 4.53906 11.1496 4.38246 10.8884 4.25568C11.3078 3.80078 11.5714 3.20419 11.5714 2.54545C11.5714 1.14595 10.4138 0 9 0ZM9 1.27273C9.71819 1.27273 10.2857 1.83452 10.2857 2.54545C10.2857 3.25639 9.71819 3.81818 9 3.81818C8.28181 3.81818 7.71429 3.25639 7.71429 2.54545C7.71429 1.83452 8.28181 1.27273 9 1.27273ZM3.85714 3.81818C4.57534 3.81818 5.14286 4.37997 5.14286 5.09091C5.14286 5.80185 4.57534 6.36364 3.85714 6.36364C3.13895 6.36364 2.57143 5.80185 2.57143 5.09091C2.57143 4.37997 3.13895 3.81818 3.85714 3.81818ZM14.1429 3.81818C14.861 3.81818 15.4286 4.37997 15.4286 5.09091C15.4286 5.80185 14.861 6.36364 14.1429 6.36364C13.4247 6.36364 12.8571 5.80185 12.8571 5.09091C12.8571 4.37997 13.4247 3.81818 14.1429 3.81818ZM9 7.63636C7.58622 7.63636 6.42857 8.78232 6.42857 10.1818C6.42857 10.8604 6.70731 11.4744 7.15179 11.9318C5.9615 12.5831 5.14286 13.8384 5.14286 15.2727H6.42857C6.42857 13.8608 7.57366 12.7273 9 12.7273C10.4263 12.7273 11.5714 13.8608 11.5714 15.2727H12.8571C12.8571 13.8384 12.0385 12.5831 10.8482 11.9318C11.2927 11.4744 11.5714 10.8604 11.5714 10.1818C11.5714 8.78232 10.4138 7.63636 9 7.63636ZM9 8.90909C9.71819 8.90909 10.2857 9.47088 10.2857 10.1818C10.2857 10.8928 9.71819 11.4545 9 11.4545C8.28181 11.4545 7.71429 10.8928 7.71429 10.1818C7.71429 9.47088 8.28181 8.90909 9 8.90909Z" fill="white"/>
                      </svg>

      <span> {{$ml.get($store.getters['pagestitle/data'].find(x=>x.name=='Eight_page').data[0])}} </span>
              </router-link>
              <div class="lined"></div>
              <router-link :to="{ name: 'nine-page', params: { student: true } }">
                
                
                <svg width="40" height="40" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.75 0C2.50912 0 1.5 1.00912 1.5 2.25V4.25391C0.627 4.56328 0 5.39738 0 6.375V9.375C0 10.4825 0.604781 11.4495 1.5 11.9692V12.375C1.5 12.582 1.668 12.75 1.875 12.75H3.75C3.957 12.75 4.125 12.582 4.125 12.375H13.875C13.875 12.582 14.043 12.75 14.25 12.75H16.125C16.332 12.75 16.5 12.582 16.5 12.375V11.9692C17.3952 11.4495 18 10.4825 18 9.375V6.375C18 5.39738 17.373 4.56328 16.5 4.25391V2.25C16.5 1.00912 15.4909 0 14.25 0H3.75ZM3.75 1.5H14.25C14.664 1.5 15 1.83562 15 2.25V4.25317C14.1269 4.56267 13.5 5.39719 13.5 6.375V7.6875C13.5 7.791 13.416 7.875 13.3125 7.875H4.6875C4.584 7.875 4.5 7.791 4.5 7.6875V6.375C4.5 5.39719 3.87313 4.56247 3 4.25317V2.25C3 1.83562 3.336 1.5 3.75 1.5ZM15.7449 5.62427H15.7463C15.7476 5.62427 15.7487 5.625 15.75 5.625C16.164 5.625 16.5 5.96063 16.5 6.375V9.375C16.5 10.2034 15.8284 10.875 15 10.875H3C2.17162 10.875 1.5 10.2034 1.5 9.375V6.375C1.5 5.96063 1.836 5.625 2.25 5.625C2.25124 5.625 2.25242 5.62501 2.25366 5.625C2.66654 5.62275 3 5.96212 3 6.375V8.625C3 9.03938 3.33562 9.375 3.75 9.375H14.25C14.6644 9.375 15 9.03938 15 8.625V6.375C15 5.96262 15.3327 5.62321 15.7449 5.62427Z" fill="white"/>
                  </svg>
          <span> {{$ml.get($store.getters['pagestitle/data'].find(x=>x.name=='Nine_page').data[0])}} </span>
        </router-link>
            </div>

            <div class="links-element student" style="margin: auto;width: 90% !important;">
              <router-link
                :to="{
                  name: 'ten-page',
                  params: { id: $store.getters['user/data'].id_user, student:true },
                }"
              >
              <svg  width="40" height="40" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.73438 0C3.4714 0 0 3.51257 0 7.82609C0 10.7089 1.565 13.2188 3.86719 14.5761V16.4348C3.86719 17.2908 4.56812 18 5.41406 18H10.0547C10.9006 18 11.6016 17.2908 11.6016 16.4348V14.5761C13.9037 13.2188 15.4688 10.7089 15.4688 7.82609C15.4688 3.51257 11.9973 0 7.73438 0ZM7.73438 1.56522C11.1605 1.56522 13.9219 4.35938 13.9219 7.82609C13.9219 11.2928 11.1605 14.087 7.73438 14.087C4.30829 14.087 1.54688 11.2928 1.54688 7.82609C1.54688 4.35938 4.30829 1.56522 7.73438 1.56522ZM7.73438 6.26087C6.87936 6.26087 6.1875 6.96094 6.1875 7.82609C6.1875 8.69124 6.87936 9.3913 7.73438 9.3913C8.58939 9.3913 9.28125 8.69124 9.28125 7.82609C9.28125 6.96094 8.58939 6.26087 7.73438 6.26087ZM17.0156 10.1739C16.1606 10.1739 15.4688 10.874 15.4688 11.7391C15.4688 12.3169 15.7799 12.8122 16.2422 13.0842V13.3043C16.2422 14.1787 15.5594 14.8696 14.6953 14.8696H12.375V16.4348H14.6953C16.3963 16.4348 17.7891 15.0255 17.7891 13.3043V13.0842C18.2513 12.8122 18.5625 12.3169 18.5625 11.7391C18.5625 10.874 17.8706 10.1739 17.0156 10.1739ZM5.41406 15.3098C6.1452 15.5421 6.9277 15.6522 7.73438 15.6522C8.54105 15.6522 9.32355 15.5421 10.0547 15.3098V16.4348H5.41406V15.3098Z" fill="white"/>
                        </svg>
                          <span> {{$ml.get($store.getters['pagestitle/data'].find(x=>x.name=='Ten_page').data[0])}} </span>
              </router-link>
              <div class="lined"></div>
              <router-link :to="{ name: 'eleven-page', params:{student:true} }">
                <svg  width="40" height="40" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.77481 0C6.44472 0 3.72436 2.61939 3.58903 5.88388C2.26994 6.29867 1.1715 6.83881 0.524394 7.42116C0.344983 7.58263 0.191561 7.74754 0.0845127 7.97967C-0.0225352 8.2118 -0.049301 8.58787 0.132133 8.86257C0.313567 9.13727 0.576667 9.24866 0.832714 9.31641C1.08876 9.38415 1.37214 9.40909 1.71651 9.40909H3.25085C2.95088 9.74201 2.74963 10.1536 2.74963 10.6364C2.74963 11.6025 3.45399 12.3832 4.36952 12.5923C4.74001 14.0467 5.35591 15.3422 6.22348 16.2933C7.17485 17.3363 8.41395 18 9.77481 18C11.1357 18 12.3748 17.3363 13.3261 16.2933C14.1937 15.3422 14.8096 14.0467 15.1801 12.5923C16.0956 12.3832 16.8 11.6025 16.8 10.6364C16.8 9.99421 16.4434 9.48054 15.9735 9.11026V6.47594C15.9736 6.45165 15.9723 6.42737 15.9695 6.40323C15.9719 6.38254 15.9732 6.36174 15.9735 6.34091V6.13636C15.9735 2.75456 13.191 0 9.77481 0ZM9.77481 1.43901C10.5356 2.14752 10.9369 3.19918 11.1017 4.19078C11.2033 4.80175 11.2224 5.34279 11.2196 5.72727H8.33007C8.32725 5.34279 8.34633 4.80175 8.44791 4.19078C8.61277 3.19918 9.01407 2.14752 9.77481 1.43901ZM8.09035 1.5269C7.60758 2.32081 7.35446 3.20822 7.22431 3.99103C7.1111 4.67197 7.08704 5.28536 7.08952 5.72727H4.89899C5.06804 3.78865 6.3311 2.16941 8.09035 1.5269ZM11.4593 1.5269C13.2185 2.16941 14.4816 3.78865 14.6506 5.72727H12.4601C12.4626 5.28536 12.4385 4.67197 12.3253 3.99103C12.1952 3.20822 11.942 2.32081 11.4593 1.5269ZM4.30253 6.95455H9.8983C8.9565 7.55022 7.50583 8.18182 5.43573 8.18182H1.71651C1.66765 8.18182 1.66007 8.17452 1.61643 8.17303C2.12903 7.80063 3.10752 7.30106 4.30253 6.95455ZM11.8903 6.95455H14.7338V9.35955C14.7337 9.47561 14.7669 9.58932 14.8294 9.68747C14.892 9.78561 14.9814 9.86419 15.0873 9.91406C15.3713 10.0477 15.5603 10.3102 15.5603 10.6364C15.5603 11.0955 15.1976 11.4545 14.7338 11.4545C14.8432 11.4545 14.8355 11.4521 14.7087 11.4521C14.5664 11.4521 14.4284 11.5005 14.3179 11.5892C14.2074 11.678 14.1311 11.8017 14.1018 11.9395C13.7945 13.389 13.1785 14.6235 12.406 15.4703C11.6335 16.3172 10.7327 16.7727 9.77481 16.7727C8.81696 16.7727 7.91608 16.3172 7.1436 15.4703C6.37111 14.6235 5.75509 13.389 5.44783 11.9395C5.41855 11.8017 5.34223 11.678 5.23171 11.5892C5.12119 11.5005 4.98319 11.4521 4.84088 11.4521C4.71413 11.4521 4.70647 11.4545 4.81586 11.4545C4.35205 11.4545 3.98937 11.0955 3.98937 10.6364C3.98937 10.3076 4.18008 10.0398 4.46153 9.90767C4.55875 9.8619 4.64224 9.79185 4.70381 9.70443C4.76537 9.61701 4.80287 9.51522 4.81263 9.40909H5.43573C9.06621 9.40909 11.2507 7.57626 11.8903 6.95455ZM7.70858 9.81818C7.48938 9.81818 7.27916 9.90438 7.12416 10.0578C6.96917 10.2113 6.88209 10.4194 6.88209 10.6364C6.88209 10.8534 6.96917 11.0615 7.12416 11.2149C7.27916 11.3683 7.48938 11.4545 7.70858 11.4545C7.92778 11.4545 8.138 11.3683 8.293 11.2149C8.448 11.0615 8.53508 10.8534 8.53508 10.6364C8.53508 10.4194 8.448 10.2113 8.293 10.0578C8.138 9.90438 7.92778 9.81818 7.70858 9.81818ZM11.841 9.81818C11.6218 9.81818 11.4116 9.90438 11.2566 10.0578C11.1016 10.2113 11.0146 10.4194 11.0146 10.6364C11.0146 10.8534 11.1016 11.0615 11.2566 11.2149C11.4116 11.3683 11.6218 11.4545 11.841 11.4545C12.0602 11.4545 12.2705 11.3683 12.4255 11.2149C12.5805 11.0615 12.6675 10.8534 12.6675 10.6364C12.6675 10.4194 12.5805 10.2113 12.4255 10.0578C12.2705 9.90438 12.0602 9.81818 11.841 9.81818Z" fill="white"/>
                            </svg>

                <span> {{$ml.get($store.getters['pagestitle/data'].find(x=>x.name=='Eleven_page').data[0])}} </span>
              </router-link>
              <div class="lined"></div>
              <router-link
                :to="{
                  name: 'twelve-page',
                  params: { student: true },
                }"
              >
              
                        <svg width="40" height="40" viewBox="0 0 35 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.1014 0.000170322C16.734 0.00594398 16.3838 0.158169 16.1278 0.42341C15.8719 0.688652 15.7311 1.04522 15.7364 1.41479C15.7364 3.27432 15.1008 3.5794 13.9451 4.50916C12.7895 5.43893 11.1138 6.99338 11.1138 9.78267C11.1112 9.96747 11.1452 10.151 11.2137 10.3225C11.2822 10.494 11.384 10.65 11.513 10.7817C11.642 10.9133 11.7958 11.0178 11.9653 11.0891C12.1349 11.1604 12.3168 11.1972 12.5006 11.1972C12.6844 11.1972 12.8663 11.1604 13.0359 11.0891C13.2054 11.0178 13.3591 10.9133 13.4882 10.7817C13.6172 10.65 13.7189 10.494 13.7875 10.3225C13.856 10.151 13.8899 9.96747 13.8873 9.78267C13.8873 7.92314 14.5229 7.61806 15.6786 6.6883C16.8342 5.75853 18.5099 4.20408 18.5099 1.41479C18.5125 1.22813 18.4779 1.04282 18.4081 0.869865C18.3382 0.696906 18.2345 0.539811 18.1032 0.407891C17.9718 0.27597 17.8155 0.171908 17.6434 0.101873C17.4714 0.031837 17.2871 -0.00274692 17.1014 0.000170322ZM22.6485 1.8597C22.281 1.86547 21.9308 2.0177 21.6749 2.28294C21.4189 2.54818 21.2781 2.90475 21.2834 3.27432C21.2834 3.97164 21.1493 4.26338 20.9602 4.53277C20.7711 4.80216 20.451 5.06484 19.9887 5.4135C19.5265 5.76217 18.9221 6.19681 18.4178 6.91529C17.9135 7.63377 17.5854 8.62046 17.5854 9.78267C17.5828 9.96747 17.6167 10.151 17.6852 10.3225C17.7538 10.494 17.8555 10.65 17.9845 10.7817C18.1136 10.9133 18.2673 11.0178 18.4369 11.0891C18.6064 11.1604 18.7883 11.1972 18.9721 11.1972C19.1559 11.1972 19.3379 11.1604 19.5074 11.0891C19.6769 11.0178 19.8307 10.9133 19.9597 10.7817C20.0888 10.65 20.1905 10.494 20.259 10.3225C20.3275 10.151 20.3615 9.96747 20.3589 9.78267C20.3589 9.08535 20.493 8.79361 20.6821 8.52422C20.8712 8.25482 21.1913 7.99215 21.6536 7.64348C22.1158 7.29482 22.7202 6.86018 23.2245 6.1417C23.7288 5.42322 24.0569 4.43652 24.0569 3.27432C24.0596 3.08766 24.025 2.90235 23.9551 2.72939C23.8852 2.55643 23.7816 2.39934 23.6502 2.26742C23.5189 2.1355 23.3625 2.03144 23.1905 1.9614C23.0184 1.89137 22.8341 1.85678 22.6485 1.8597ZM1.40651 13.0368C1.22275 13.0342 1.0403 13.0684 0.869775 13.1373C0.699247 13.2062 0.54404 13.3085 0.413172 13.4383C0.282304 13.568 0.178385 13.7227 0.107456 13.8932C0.0365262 14.0637 0 14.2467 0 14.4315C0 14.6163 0.0365262 14.7993 0.107456 14.9698C0.178385 15.1403 0.282304 15.2949 0.413172 15.4247C0.54404 15.5545 0.699247 15.6568 0.869775 15.7257C1.0403 15.7946 1.22275 15.8287 1.40651 15.8261H1.86876V33.0268C1.86876 36.8557 4.99528 40 8.80256 40H22.6702C26.4774 40 29.6039 36.8557 29.6039 33.0268V32.5619H30.5285C34.0724 32.5619 37 29.6176 37 26.0535C37 22.4894 34.0724 19.5452 30.5285 19.5452H29.6039V15.8261H30.0662C30.25 15.8287 30.4324 15.7946 30.6029 15.7257C30.7735 15.6568 30.9287 15.5545 31.0595 15.4247C31.1904 15.2949 31.2943 15.1403 31.3653 14.9698C31.4362 14.7993 31.4727 14.6163 31.4727 14.4315C31.4727 14.2467 31.4362 14.0637 31.3653 13.8932C31.2943 13.7227 31.1904 13.568 31.0595 13.4383C30.9287 13.3085 30.7735 13.2062 30.6029 13.1373C30.4324 13.0684 30.25 13.0342 30.0662 13.0368H29.6039H1.86876H1.40651ZM4.64228 15.8261H26.8304V33.0268C26.8304 35.3343 24.9646 37.2107 22.6702 37.2107H8.80256C6.5081 37.2107 4.64228 35.3343 4.64228 33.0268V15.8261ZM12.5331 21.412C11.9415 21.4354 11.3558 21.6136 10.8358 21.9622C8.89429 23.2639 8.70975 25.8679 10.2814 27.3556L15.182 32.2822C15.4594 32.5612 15.9213 32.5612 16.1986 32.2822L21.0992 27.3556C22.6709 25.8679 22.486 23.2639 20.637 21.9622C19.2502 21.0324 17.4005 21.311 16.1986 22.5197L15.7364 22.9846L15.2741 22.5197C14.5229 21.7643 13.519 21.3729 12.5331 21.412ZM29.6039 22.3345H30.5285C32.5316 22.3345 34.2265 24.039 34.2265 26.0535C34.2265 28.068 32.5316 29.7726 30.5285 29.7726H29.6039V22.3345Z" fill="white"/>
                </svg>

                <span> {{$ml.get($store.getters['pagestitle/data'].find(x=>x.name=='Twelve_page').data[0])}} </span>
              </router-link>
            </div>
          </div>
          <div>
            <div class="links-element student" style="margin: auto;width: 90% !important;">
              <router-link :to="{ name: 'fromTheHassle', params: { student: true } }">
                <svg
                  width="29"
                  height="32"
                  viewBox="0 0 29 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M26.625 0L21.675 9.48207C21.5719 9.44024 21.2625 9.31009 21.225 9.29615C19.5469 8.58035 17.5266 9.26826 16.6875 10.9323L27.1125 15.5803C27.9516 13.7955 27.1031 11.7968 25.425 11.081C25.3875 11.0671 25.1016 10.9323 25.0125 10.8951L28.8 0.966799L26.625 0ZM1.8 1.78486C0.80625 1.78486 0 2.58433 0 3.56972C0 4.55511 0.80625 5.35458 1.8 5.35458C2.79375 5.35458 3.6 4.55511 3.6 3.56972C3.6 2.58433 2.79375 1.78486 1.8 1.78486ZM7.2 2.97477C6.53906 2.97477 6 3.5093 6 4.16467C6 4.82005 6.53906 5.35458 7.2 5.35458C7.86094 5.35458 8.4 4.82005 8.4 4.16467C8.4 3.5093 7.86094 2.97477 7.2 2.97477ZM6.6 7.7344C4.94531 7.7344 3.6 9.06839 3.6 10.7092C3.6 12.3499 4.94531 13.6839 6.6 13.6839C8.25469 13.6839 9.6 12.3499 9.6 10.7092C9.6 9.06839 8.25469 7.7344 6.6 7.7344ZM15.75 12.5312C14.5828 14.7483 12.1781 16.1195 9.825 16.8818C8.64844 17.2629 7.51875 17.5 6.6 17.6255C5.68125 17.751 4.9125 17.7463 4.8 17.7371L3.4875 17.6255V19.4847L3.75 19.8194C10.3687 27.6421 20.475 27.9628 20.475 27.9628L21.075 28L21.45 27.5166C21.45 27.5166 24.3703 23.998 26.5875 17.4024L24.3 16.6215C22.4484 22.1295 20.4562 24.8161 19.95 25.4714C19.6266 25.4529 18.5109 25.3274 16.95 24.9137C17.4609 24.3187 18.2859 23.1614 19.2 21.0465C16.7484 23.2636 15.1641 23.8725 14.2875 24.0212C13.3781 23.6633 12.4266 23.2357 11.4375 22.6826C11.8781 22.2503 12.4875 21.5113 13.2 20.2284C12.2531 21.2417 10.9594 21.674 10.05 21.8645C9.17813 21.2928 8.31563 20.6235 7.4625 19.8566C8.40469 19.7078 9.43594 19.5219 10.575 19.1501C13.2609 18.2762 16.2609 16.6633 17.85 13.6467L15.75 12.5312Z"
                    fill="white"
                  />
                </svg>
                <span>{{ $ml.get(takeHeader(3)) }}</span>
              </router-link>
              <div class="lined"></div>
              <router-link :to="{ name: 'matched-games', params:{student:true} }">
            
                <svg width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 0C4.43649 0 2.33333 2.10316 2.33333 4.66667C2.33333 7.23018 4.43649 9.33333 7 9.33333C9.56351 9.33333 11.6667 7.23018 11.6667 4.66667C11.6667 2.10316 9.56351 0 7 0ZM7 2.33333C8.30248 2.33333 9.33333 3.36418 9.33333 4.66667C9.33333 5.96915 8.30248 7 7 7C5.69752 7 4.66667 5.96915 4.66667 4.66667C4.66667 3.36418 5.69752 2.33333 7 2.33333ZM25.6667 2.33333C23.1032 2.33333 21 4.43649 21 7C21 9.56351 23.1032 11.6667 25.6667 11.6667C28.2302 11.6667 30.3333 9.56351 30.3333 7C30.3333 4.43649 28.2302 2.33333 25.6667 2.33333ZM25.6667 4.66667C26.9691 4.66667 28 5.69752 28 7C28 8.30248 26.9691 9.33333 25.6667 9.33333C24.3642 9.33333 23.3333 8.30248 23.3333 7C23.3333 5.69752 24.3642 4.66667 25.6667 4.66667ZM16.3333 9.33333C13.7698 9.33333 11.6667 11.4365 11.6667 14C11.6667 16.5635 13.7698 18.6667 16.3333 18.6667C18.8968 18.6667 21 16.5635 21 14C21 11.4365 18.8968 9.33333 16.3333 9.33333ZM16.3333 18.6667H14.4421L14.0911 18.9447C13.6711 19.318 13.3007 19.7181 12.9974 20.1615H12.9746C10.9446 22.7048 9.93909 26.2733 9.56575 28H11.9447C12.4113 26.1567 13.4641 22.8667 15.3307 21H17.3132C18.3398 22.1433 19.1583 23.7535 19.765 25.2702V25.293C20.1616 26.2963 20.4619 27.2533 20.6719 28H23.0781C22.9148 27.3233 22.6089 26.3218 22.2122 25.2018V25.1745C21.8156 24.1011 21.3247 22.9124 20.6947 21.8158C20.3913 21.2324 20.0432 20.6976 19.6465 20.1842C19.3198 19.7409 18.9716 19.3448 18.5983 18.9948L18.2474 18.6667H16.3333ZM3.5 11.6667C1.56333 11.6667 0 13.23 0 15.1667V22.6589L2.33333 24.9922V28H4.66667V24.0078L2.33333 21.6745V15.1667C2.33333 14.5133 2.84667 14 3.5 14H9.33333C9.33333 13.1833 9.4726 12.39 9.7526 11.6667H3.5ZM16.3333 11.6667C17.6358 11.6667 18.6667 12.6975 18.6667 14C18.6667 15.3025 17.6358 16.3333 16.3333 16.3333C15.0308 16.3333 14 15.3025 14 14C14 12.6975 15.0308 11.6667 16.3333 11.6667ZM23.3561 14L23.0052 14.4421C22.5385 15.0487 22.1218 15.7285 21.7018 16.4518C21.4452 16.9185 21.2105 17.4059 20.9772 17.9193C20.9539 17.9659 20.955 17.9911 20.9316 18.0378C21.1183 18.2711 21.3055 18.5245 21.4922 18.7578C21.8889 19.2711 22.2376 19.8082 22.5176 20.2982C23.0776 18.8282 23.73 17.43 24.5 16.3333H26.8105C28.7939 19.4133 30.7083 24.5467 31.4316 28H33.8333C33.04 24.1733 30.8937 17.9922 28.3737 14.4922L28 14H23.3561Z" fill="white"/>
      </svg>

                <span>{{ $ml.get(takeHeader(2)) }}</span>
              </router-link>
              <div class="lined"></div>
              <router-link
                :to="{
                  name: 'parents-educational-classes',
                  params: { id: $store.getters['user/data'].id_user, student:true },
                }"
              >
              
                <svg width="32" height="32" viewBox="0 0 20 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.08651 0C5.04268 0 3.23876 0.590542 1.95617 1.84544C0.673588 3.10035 0 4.94579 0 7.0865C0 10.5052 1.94694 14.1776 4.28143 17.1257C5.44867 18.5975 6.70819 19.8662 7.97232 20.8166C8.78432 21.4256 9.58247 21.9054 10.4083 22.1822C10.3391 22.3345 10.2837 22.4867 10.1869 22.6621C9.91465 23.1511 9.44868 23.8247 9.44868 24.8028C9.44868 26.1684 10.4037 26.8881 10.9988 27.4602C11.2987 27.7463 11.5617 27.9815 11.7001 28.1615C11.8385 28.3414 11.8108 28.4106 11.8108 28.346C11.8108 29.1534 10.6667 29.8962 10.6667 29.8962L11.7739 32C11.7739 32 14.173 30.842 14.173 28.346C14.173 27.6632 13.8501 27.1188 13.5456 26.722C13.2411 26.3253 12.9135 26.0438 12.6228 25.7624C12.0369 25.1995 11.8108 24.7566 11.8108 24.8028C11.8108 24.6367 11.9354 24.4106 12.2538 23.8431C12.466 23.4648 12.6967 22.9343 12.8443 22.293C13.7762 22.0484 14.6897 21.504 15.6125 20.8166C16.8766 19.8754 18.173 18.6298 19.3403 17.1626C21.6794 14.2284 23.6217 10.5513 23.6217 7.0865C23.6217 4.94579 22.9481 3.10035 21.6655 1.84544C20.3829 0.590542 18.579 0 16.5352 0C14.1776 0 12.8351 1.11649 11.8478 1.99308C10.9758 1.14418 9.73933 0 7.08651 0ZM7.08651 2.36217C9.61477 2.36217 9.67013 3.31257 11.0727 4.46597L11.8108 5.05652L12.549 4.46597C13.8316 3.40946 14.5236 2.36217 16.5352 2.36217C18.1269 2.36217 19.2803 2.79585 20.0415 3.54325C20.8028 4.29066 21.2595 5.41638 21.2595 7.0865C21.2595 9.60092 19.6125 13.0288 17.4948 15.6863C16.4383 17.015 15.2618 18.1499 14.2099 18.9343C13.158 19.7186 12.203 20.0784 11.8108 20.0784C11.4279 20.0784 10.4637 19.7232 9.41177 18.9343C8.35986 18.1453 7.18801 16.9873 6.12688 15.6494C4.00923 12.9781 2.36217 9.53633 2.36217 7.0865C2.36217 5.41638 2.81892 4.29066 3.58016 3.54325C4.34141 2.79585 5.49481 2.36217 7.08651 2.36217Z" fill="white"/>
                </svg>

                <span> {{ $ml.get(takeHeader(1)) }} </span>
              </router-link>
            </div>

            <div class="links-element student" style="margin: auto;width: 90% !important;">
              <router-link
                :to="{
                  name: 'teacher-educational-classes',
                  params: { student: true },
                }"
              >
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.19723 0V2.33333H7.43253L0 9.67513L1.67013 11.3249L9.10265 3.98307V8.16667H11.4648V0H3.19723ZM22.0946 0C20.1517 0 18.5513 1.58087 18.5513 3.5C18.5513 5.41913 20.1517 7 22.0946 7C24.0374 7 25.6378 5.41913 25.6378 3.5C25.6378 1.58087 24.0374 0 22.0946 0ZM22.0946 2.33333C22.7619 2.33333 23.2757 2.8408 23.2757 3.5C23.2757 4.1592 22.7619 4.66667 22.0946 4.66667C21.4272 4.66667 20.9135 4.1592 20.9135 3.5C20.9135 2.8408 21.4272 2.33333 22.0946 2.33333ZM20.9135 8.16667C18.308 8.16667 16.1892 10.2597 16.1892 12.8333V18.9561L18.5513 20.1227V28H20.9135V18.6826L18.5513 17.5159V12.8333C18.5513 11.5465 19.6108 10.5 20.9135 10.5H23.2757C24.5784 10.5 25.6378 11.5465 25.6378 12.8333V17.5159L23.2757 18.6826V28H25.6378V20.1227L28 18.9561V12.8333C28 10.2597 25.8811 8.16667 23.2757 8.16667H20.9135ZM11.4648 14V28H13.827V14H11.4648ZM6.74048 18.6667V28H9.10265V18.6667H6.74048ZM2.01615 23.3333V28H4.37832V23.3333H2.01615Z"
                    fill="white"
                  />
                </svg>

                <span>{{ $ml.get(takeHeader(6)) }}</span>
              </router-link>
              <div class="lined"></div>
              <router-link :to="{ name: 'learningSkills', params:{student:true} }">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.9999 16.8C20.7885 16.8 20.5799 16.7818 20.3713 16.7678C19.3143 18.3372 18.1789 20.3756 18.1789 24.136V25.2H11.1789V21H5.57891V14.9716L3.86671 14.2492L3.52931 14.1078L5.21071 11.4702L5.56211 10.92L5.63351 10.2718C6.02831 6.6794 8.65191 3.857 12.0343 3.0534C12.5397 1.9068 13.2565 0.875 14.1399 0.00840006C14.0853 0.00700006 14.0321 0 13.9789 0C8.21091 0 3.46491 4.361 2.85171 9.9652L0.201512 14.1218C-0.225488 14.7896 0.0531116 15.6814 0.782512 15.988L2.77891 16.8294V21C2.77891 22.547 4.03191 23.8 5.57891 23.8H8.37891V28H20.9789V24.136C20.9789 19.754 22.7541 18.5556 23.9959 16.3296C23.0509 16.6334 22.0457 16.8 20.9999 16.8Z"
                    fill="white"
                  />
                  <path
                    d="M26.4619 8.064C26.5277 7.7182 26.5683 7.364 26.5683 7C26.5683 6.636 26.5277 6.2818 26.4605 5.936L27.5889 5.0974C27.7331 4.9896 27.7751 4.7908 27.6841 4.6354L26.3737 2.366C26.2841 2.2092 26.0909 2.1462 25.9257 2.2176L24.6153 2.7846C24.0847 2.3254 23.4715 1.967 22.7939 1.7318L22.6315 0.3136C22.6105 0.1344 22.4593 0 22.2787 0H19.6579C19.4773 0 19.3261 0.1344 19.3051 0.3136L19.1413 1.7304C18.4637 1.9656 17.8519 2.3226 17.3199 2.7832L16.0095 2.2162C15.8443 2.1448 15.6511 2.2078 15.5615 2.3646L14.2511 4.634C14.1615 4.7908 14.2021 4.9896 14.3463 5.096L15.4747 5.9346C15.4089 6.279 15.3669 6.6346 15.3669 6.9986C15.3669 7.3626 15.4075 7.7168 15.4747 8.0626L14.3463 8.9012C14.2021 9.009 14.1601 9.2078 14.2511 9.3632L15.5615 11.6326C15.6511 11.7894 15.8443 11.8524 16.0095 11.781L17.3199 11.214C17.8505 11.6732 18.4637 12.0316 19.1413 12.2668L19.3051 13.6836C19.3261 13.8656 19.4787 14 19.6579 14H22.2787C22.4593 14 22.6105 13.8656 22.6315 13.6864L22.7953 12.2696C23.4729 12.0344 24.0847 11.6774 24.6167 11.2168L25.9271 11.7838C26.0923 11.8552 26.2855 11.7908 26.3751 11.6354L27.6855 9.366C27.7751 9.2092 27.7345 9.0104 27.5903 8.904L26.4619 8.064ZM20.9683 9.45C19.6159 9.45 18.5183 8.3524 18.5183 7C18.5183 5.6462 19.6159 4.55 20.9683 4.55C22.3207 4.55 23.4183 5.6462 23.4183 7C23.4183 8.3524 22.3221 9.45 20.9683 9.45Z"
                    fill="white"
                  />
                </svg>

                <span>{{ $ml.get(takeHeader(4)) }}</span>
              </router-link>
              <div class="lined"></div>
              <router-link
                :to="{
                  name: 'communicationSkills',
                  params: { id: $store.getters['user/data'].id_user, student:true },
                }"
              >
              <svg 
                        width="40" height="28" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M32.5529 0C31.2555 0 30.1051 0.542498 29.3739 1.37274C28.6427 2.20299 28.3068 3.25391 28.3068 4.28564C28.3068 4.99131 28.4767 5.70346 28.81 6.35034C28.5988 6.36184 28.3929 6.42095 28.2073 6.52332L19.378 11.4284H15.5688C15.1934 11.4284 14.8334 11.5789 14.568 11.8468C14.3026 12.1147 14.1535 12.4781 14.1534 12.8569V17.1426H0V19.9997H19.8148C20.0313 20.0001 20.245 19.9505 20.4395 19.8546L29.9212 15.1616L31.414 19.0845C31.4931 19.292 31.6191 19.4779 31.7819 19.6276C31.9448 19.7773 32.14 19.8866 32.352 19.9467C32.5641 20.0069 32.7871 20.0162 33.0034 19.9741C33.2196 19.9319 33.4232 19.8394 33.5978 19.7039L40 14.7151L38.2695 12.4496L33.3711 16.2665L32.0829 12.8737C32.0726 12.8246 32.0596 12.7762 32.0442 12.7286L30.4686 8.03557C31.0781 8.36455 31.7828 8.57128 32.5529 8.57128C33.8503 8.57128 35.0007 8.02878 35.7319 7.19854C36.463 6.36829 36.7989 5.31737 36.7989 4.28564C36.7989 3.25391 36.463 2.20299 35.7319 1.37274C35.0007 0.542498 33.8503 0 32.5529 0ZM32.5529 2.85709C33.1426 2.85709 33.4075 3.02887 33.6199 3.27003C33.8323 3.5112 33.9682 3.88882 33.9682 4.28564C33.9682 4.68246 33.8323 5.06008 33.6199 5.30125C33.4075 5.54241 33.1426 5.71419 32.5529 5.71419C31.9631 5.71419 31.6982 5.54241 31.4858 5.30125C31.2734 5.06008 31.1375 4.68246 31.1375 4.28564C31.1375 3.88882 31.2734 3.5112 31.4858 3.27003C31.6982 3.02887 31.9631 2.85709 32.5529 2.85709ZM4.66068 8.39829L2.74223 10.502L6.80581 14.2855H10.9744L4.66068 8.39829ZM28.0912 9.84916L28.9648 12.4551L19.4886 17.1426H16.9841V14.2855H19.7429C19.9809 14.2846 20.2147 14.2232 20.4229 14.1069L28.0912 9.84916Z" fill="white"/>
                          </svg>
                <span> {{ $ml.get(takeHeader(5)) }} </span>
              </router-link>
            </div>
          </div>
        </VueSlickCarousel>

        <div style="position: absolute; position: absolute;left: 0;right: 0;margin: auto;width: 20px;height: 20px;bottom: -18px;">
          <div style="position: relative;">
            <div :class="prev?'active':null" style="position: absolute;position: absolute;width: 6px;height: 6px;border-radius: 50%;background: #D9D9D9;left: 0;">
            </div>

            <div :class="next?'active':null" style="position: absolute;position: absolute;width: 6px;height: 6px;border-radius: 50%;background: #D9D9D9;left: 1;">
            </div>
          </div>
        </div>
        <span v-if="next" @click="nextSlide" style="cursor:pointer"><svg style="position: absolute;top: 43%;fill: white; left: -24px;" width="23" height="26" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg"><title/><path d="M39.3756,48.0022l30.47-25.39a6.0035,6.0035,0,0,0-7.6878-9.223L26.1563,43.3906a6.0092,6.0092,0,0,0,0,9.2231L62.1578,82.615a6.0035,6.0035,0,0,0,7.6878-9.2231Z "/></svg></span>
        <span  v-else-if="prev" @click="prevSlide" style="cursor:pointer"><svg style="position: absolute;top: 43%;fill: white; right: -24px;" width="23" height="26" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg"><title/><path d="M69.8437,43.3876,33.8422,13.3863a6.0035,6.0035,0,0,0-7.6878,9.223l30.47,25.39-30.47,25.39a6.0035,6.0035,0,0,0,7.6878,9.2231L69.8437,52.6106a6.0091,6.0091,0,0,0,0-9.223Z"/></svg></span>
      </div>
    </div>
    <div v-if="!$store.getters['sub/getDisabled']" @click="()=>{this.$router.push('/subsPlans')}" style="cursor:pointer;height: 44px; width: 100%; background: #00465B; padding: 5px 32px 5px 5px;">
      <span style="position: relative;font-family: 'App';font-style: normal;font-weight: 400;
      font-size: 14px;line-height: 19px;text-align: right;color: #FFFFFF;">
      <svg style="position: absolute;bottom: 3px;left: 111px;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.33333 0C4.23669 0 3.33333 0.903353 3.33333 2C3.33333 2.2589 3.51932 2.43866 3.61068 2.66667H0V3.33333V7.33333H0.666667V16H15.3333V7.33333H16V2.66667H12.3893C12.4807 2.43866 12.6667 2.2589 12.6667 2C12.6667 0.903353 11.7633 0 10.6667 0C9.50073 0 8.71354 0.878294 8.19401 1.61719C8.06978 1.79387 8.09736 1.8019 8 1.96745C7.90264 1.8019 7.93022 1.79387 7.80599 1.61719C7.28646 0.878294 6.49927 0 5.33333 0ZM5.33333 1.33333C5.75073 1.33333 6.29688 1.78837 6.71484 2.38281C6.81353 2.52317 6.79357 2.53312 6.8724 2.66667H5.33333C4.95665 2.66667 4.66667 2.37669 4.66667 2C4.66667 1.62331 4.95665 1.33333 5.33333 1.33333ZM10.6667 1.33333C11.0434 1.33333 11.3333 1.62331 11.3333 2C11.3333 2.37669 11.0434 2.66667 10.6667 2.66667H9.1276C9.20643 2.53312 9.18647 2.52317 9.28516 2.38281C9.70312 1.78837 10.2493 1.33333 10.6667 1.33333ZM1.33333 4H5.33333H7.00911H7.33333V6H1.33333V4ZM8.66667 4H8.99089H10.6667H14.6667V6H8.66667V4ZM2 7.33333H7.33333V14.6667H2V7.33333ZM8.66667 7.33333H14V14.6667H8.66667V7.33333Z" fill="white"/>
      </svg>
    {{ $ml.get('רכישת מנוי כמתנה') }}
    </span>
    </div>
  </div>
</template>

<script>
import TeacherProfileButton from "../../components/teacher/TeacherLinkTo";
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  name: "MainHeader",
  components: {
    TeacherProfileButton,
    VueSlickCarousel
  },
  props: {
    isProfteacher: {},
    position: {},
  },
  methods: {
    nextSlide()
    {
      
      this.$refs.carousel.prev()
    },
    prevSlide()
    {
      this.$refs.carousel.next()
    },
    afterChange(val)
    {
      if(val==0)
      {
        this.index=val;
        this.next=false;
        this.prev=true;
      }
      else if(val==1)
      {
        this.index=val;
        this.next=true;
        this.prev=false;
      }
    },
    takeHeader(val)
    {
      switch(val)
      {
        case 1:
          
          return this.$store.getters['pagestitle/data'].find(x=>x.name=='First_page').data[0];
          break;
          case 2:
          
          return this.$store.getters['pagestitle/data'].find(x=>x.name=='Second_page').data[0];
          break;
          case 3:
          
          return this.$store.getters['pagestitle/data'].find(x=>x.name=='Third_page').data[0];
          break;
          case 4:
          
          return this.$store.getters['pagestitle/data'].find(x=>x.name=='Fourth_page').data[0];
          break;
          case 5:
          
          return this.$store.getters['pagestitle/data'].find(x=>x.name=='Fifth_page').data[0];
          break;
          case 6:
          
          return this.$store.getters['pagestitle/data'].find(x=>x.name=='Sixth_page').data[0];
          break;
          default:
            break;
      }

    }
  },
  data(){
    return{
      next:true,
      prev:false,
      index:1
    }
  }
};
</script>

<style scoped lang="scss">
.active{
  background-color: #3FBCD4 !important;
  width: 8px !important;
  height: 8px !important;
  top: -1.5px;
}
.test::v-deep .slick-dots li button{
  content: "*";
}
.test::v-deep .slick-dots li button::before{
  color:transparent !important;
  background-color: #D9D9D9;
  opacity: 100%;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  padding: 3px !important;
}

.test::v-deep .slick-active button::before{
  color:transparent !important;
  background-color: #3FBCD4 !important;
  opacity: 100%;
  width: 6px !important;
  height: 6px !important;
  border-radius: 50%;
}

.test::v-deep .slick-dots li{
  position: relative;
    display: inline-block;
    width: 6px !important;
    height: 6px !important;
    margin: 0;
    padding: 0;
    cursor: pointer;
    margin: 0 3px;
}

.test::v-deep .slick-dots li button{
  width: 12px !important;
    height: 12px !important;
}

.test::v-deep .slick-dots {
  bottom: -15px !important;
}
// .test::v-deep .VueCarousel-inner
// {
//   flex-basis: 100% !important;
// }
// .test::v-deep .VueCarousel-pagination{
//   height: 0px !important;
// }

// .test::v-deep .VueCarousel-dot-container{
//   position: absolute;
//   bottom: -13px;
//   left: 0px;
//   right: 0px;
//   margin: auto;
// }

// .test::v-deep .material-icons{
//   scale: 1.3;
// }

// .test::v-deep .VueCarousel-dot {
//   width: 6px !important;
//   height: 6px !important;
//   padding: 1px !important;
//   border: 1px solid transparent !important;
// }

// .test::v-deep .VueCarousel-dot.VueCarousel-dot--active{
//   // margin: 0px !important;
//   background-color: #3FBCD4 !important;
//   border: 1px solid transparent !important;
//   padding: 0 !important;
//   margin: 3px !important;
//   margin-top: 23px !important;
//   width: 8px !important;
//   height: 8px !important;
// }
  .line{
    hr{
      overflow: hidden;
      height:1px;
      border:none;
      color: rgba(255, 255, 255, 0.3);
      background-color: rgba(255, 255, 255, 0.3);
    }
  .decore-hr{
    color: black !important;
  }
}

// .test::v-deep .VueCarousel-navigation-prev{
//   left: 35px !important;
//     position: absolute !important;
// }

// .test::v-deep .VueCarousel-navigation-next{
//   right: 35px;
//   position: absolute;
// }

// .test::v-deep .VueCarousel-navigation-button{
//   color: #fff !important;
// }

// .test::v-deep .VueCarousel-navigation--disabled{
//   display: none;
// }
.relative-div {
  position: relative;
}
.title-inside{
  position: absolute;
  left: 0;
  right: 0;
  top: 0px;
}
.absolute-div {
  border-radius: 10px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  top: -30px;
  text-align: center;
  // width: 142.99px;
  height: 34px !important;
  // background-color: #06364b;
  position: absolute;
  .inside-div{
    display: inline-block;
    text-align: center;
    width: 33%;
    
    span {
    font-family: 'Kartiv';
    // font-style: italic;
    font-weight: 400;
    font-size: 20px;
    line-height: 18px;
    /* identical to box height, or 90% */

    text-align: center;

    color: #FFFFFF;

    padding-top: 10px;
  }
  }
  span {
    font-family: 'Kartiv';
    // font-style: italic;
    font-weight: 700;
    font-size: 20px;
    line-height: 18px;
    /* identical to box height, or 90% */

    text-align: center;

    color: #FFFFFF;

    padding-top: 10px;
  }
}
.main-footer {
  text-align: center;
  p {
    font-size: 1.8rem; /*22px;*/
    margin: 0;
  }
  .wrapper {
    position: relative;
    top: 1rem;
  }
  .links-element {
    direction: rtl;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    // background: #06364b;
    // padding: 12px 14px;
    &.student {
      
      max-height: 95px !important;
      // padding: 10px 14px 8px 14px;
      @media screen and (min-width: 380px) {
        justify-content: space-around;
      }
      a {
        width: 33%;
        height: 100px;
        span {
          margin-top: 8px;
          // font-family: "Open Sans Hebrew";
          font-style: normal;
          font-weight: 100;
          font-size: 14px;
          line-height: 18px;
          /* identical to box height, or 129% */

          text-align: center;

          color: #ffffff;
        }
      }
    }
    .lined {
      width: 1px;
      position: relative;
      // &:before{
      //   position: absolute;
      //   content: '';
      //   width: 80px;
      //   right: -40px;
      //   height: 0px;
      //   border: 1px solid #00465B;
      //   transform: rotate(90deg);
      // }
    }
    a {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      svg {
      }
      span {
        text-align: center;
        font-weight: normal;
        font-size: 18px;
        color: #ffffff;
      }
    }
  }
}
</style>
